module.exports = "/static/assets/7696a504b61394f1d39fd510d22ee064.gif";